import { render, staticRenderFns } from "./directoryDetailEn.vue?vue&type=template&id=5def6504&scoped=true&lang=html&"
import script from "./directoryDetailEn.vue?vue&type=script&lang=js&"
export * from "./directoryDetailEn.vue?vue&type=script&lang=js&"
import style0 from "./directoryDetailEn.vue?vue&type=style&index=0&id=5def6504&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5def6504",
  null
  
)

export default component.exports